import script from "./MainCommnetInputCf.vue?vue&type=script&setup=true&lang=js"
export * from "./MainCommnetInputCf.vue?vue&type=script&setup=true&lang=js"

import "./MainCommnetInputCf.vue?vue&type=style&index=0&id=18b6415a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18b6415a"]])

export default __exports__